import { useStore } from "@tanstack/react-store";
import { AlertDialog } from "@/components/ui/alert-dialog";
import { alertStore, closeAlert } from "@/store/alert.store";
import { NpsErrorAlert } from "./nps-error-alert";
import { NpsLoadingAlert } from "./nps-loading-alert";
import { NpsSuccessAlert } from "./nps-success-alert";

export const alerts = {
	NpsErrorAlert,
	NpsLoadingAlert,
	NpsSuccessAlert,
} as const;

export type AlertDataMap = {
	[K in keyof typeof alerts]: React.ComponentProps<(typeof alerts)[K]>;
};

export type TAlertKeys = keyof typeof alerts;

export function AlertRoot() {
	const alertState = useStore(alertStore, (state) => state);

	const AlertComponent = alertState.alertKey
		? (alerts[alertState.alertKey as TAlertKeys] as React.ComponentType<
				Record<string, unknown>
			>)
		: null;

	return (
		<AlertDialog
			open={alertState.isOpen}
			onOpenChange={(open) => !open && closeAlert()}
		>
			{AlertComponent && (
				<AlertComponent
					{...(alertState.data as React.ComponentProps<typeof AlertComponent>)}
				/>
			)}
		</AlertDialog>
	);
}
